import { useState } from "react";
import useDownloadCSV from "../other/useDownloadCSV.other.hook";

const REPORT_HEADERS = [
  "Employee Name",
  "QA Date",
  "Ticket Number",
  "Invoice Number",
  "Invoice Total",
  "COGS Total",
  "Net Revenue",
  "Customer Business Name",
  "Asset Make",
  "Asset Model",
  "Asset Type",
  "Asset Serial",
];

const useEmployeeReport = () => {
  const [report, setReport] = useState(null);
  const handleDownload = useDownloadCSV();
  const generateEmployeeReport = async (rois, filename = "Employee ROI") => {
    try {
      const data = [];
      if (!rois || !rois.length) throw new Error("No ROIs found");
      for (let i = 0; i < rois.length; i++) {
        const roi = rois[i];
        const {
          employee,
          ticket,
          asset,
          customer,
          invoice,
          qa_date,
          discount_total,
          warranty_total,
        } = roi;
        const { name, id } = employee;
        const { make, model, type, serial } = asset;
        const { business_name } = customer;
        const { number: ticket_number } = ticket;
        const { number: invoice_number, cogs, net_revenue, total } = invoice;
        data.push([
          name || "*Missing from DB*",
          qa_date || "*Missing from DB*",
          ticket_number || "*Missing from DB*",
          invoice_number || "*Missing from DB*",
          total || "*Missing from DB*",
          cogs || "*Missing from DB*",
          net_revenue || "*Missing from DB*",
          // discount_total && discount_total !== "0.00" ? discount_total : "-",
          // warranty_total && warranty_total !== "0.00" ? warranty_total : "-",
          business_name || "*Missing from DB*",
          make || "*Missing from DB*",
          model || "*Missing from DB*",
          type || "*Missing from DB*",
          serial || "*Missing from DB*",
        ]);
      }
      handleDownload({ data, headers: REPORT_HEADERS, filename });
    } catch (error) {
      console.error(`Error generating employee report: ${error.message}`);
      alert(`Error generating employee report: ${error.message}`);
    }
  };

  return { report, setReport, generateEmployeeReport };
};

export default useEmployeeReport;
